import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FromUTCPipe } from './from-utc.pipe';

@NgModule({
  declarations: [FromUTCPipe],
  imports: [CommonModule],
  exports: [FromUTCPipe]
})
export class FromUTCModule {}
